<template>
  <div>
    <DatapropAuth></DatapropAuth>
  </div>
</template>

<script>
import DatapropAuth from '../components/DataproposalAuth.vue';

export default {
  components: {
    DatapropAuth,
  },
};
</script>